import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.adUsers,
      "show-borders": true,
      "column-auto-width": true,
      "row-alternation-enabled": true,
      "allow-column-reordering": true,
      "allow-column-resizing": true,
      "remote-operations": false,
      "filter-row": { visible: true, applyFilter: 'auto' },
      "header-filter": { visible: true },
      height: "600px"
    }, {
      accountCell: _withCtx(({ data }) => [
        _createElementVNode("div", null, [
          (!data.value)
            ? (_openBlock(), _createBlock(_component_DxButton, {
                key: 0,
                text: "Generează cont",
                type: "success",
                stylingMode: "contained",
                onClick: ($event: any) => (_ctx.generateAccount(data.data))
              }, null, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_DxButton, {
                key: 1,
                text: "Are cont",
                type: "danger",
                stylingMode: "contained",
                disabled: ""
              }))
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxPaging, { "page-size": 10 }),
        _createVNode(_component_DxPager, {
          "show-page-size-selector": true,
          "allowed-page-sizes": [5,10,20],
          "show-info": ""
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "samAccountName",
          caption: "Username",
          allowSorting: true
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "displayName",
          caption: "Nume complet",
          allowSorting: true
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "email",
          caption: "Email",
          allowSorting: true
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AreCont",
          caption: "Are Cont",
          "cell-template": "accountCell",
          "allow-sorting": true
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: _ctx.APP_Color
          }, null, 8, ["color"])
        ]))
      : _createCommentVNode("", true)
  ]))
}